import React, { Fragment, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { HeaderBlock } from "../../../components/header-block/HeaderBlock";
import {
  getFormJson,
  clearForm,
  createForm,
  deleteForms,
  updateForm
} from "../../../state/actions/FormsActions";
import { Loading } from "../../../components/loading/Loading";
import {
  Button,
  Checkbox,
  TextField,
  Grid,
  ButtonGroup,
  Snackbar
} from "@material-ui/core";
import MuiAlert from '@material-ui/lab/Alert';

import PageContainer from "../../../components/page-container/PageContainer";
import styles from "./FormManager.module.scss";
import {
  generateFormComponents,
  generateId,
  formHasBeenChanged,
  validateForm
} from "./../FormsLibrary";
import Editor from "react-simple-code-editor";
import "./EditorStyles.css";

import { JsonEditor } from "jsoneditor-react";
import "jsoneditor-react/es/editor.min.css";
import CustomizedSnackbars from "../../../components/snackbar/Snackbar";

import { highlight, languages } from "prismjs/components/prism-core";
import "prismjs/components/prism-clike";
import "prismjs/components/prism-javascript";
import "prismjs/components/prism-json";
import "prismjs/components/prism-markup";
import AlertDialog from "../../../components/alert-dialog/AlertDialog";
import ScrollableTabs from "../../../components/tabs/Tabs";
import { useTranslation } from "react-i18next";

export default function FormEditor({ ...props }) {
  const dispatch = useDispatch();
  const formOutlineId = props.match.params.formId;
  const isNewForm = props.match.params.formId === undefined;
  const form = useSelector(state => state.FormReducer.form);

  const [t, i18n] = useTranslation()

  const [alertShowing, setAlertShowing] = useState(false);
  const [formData, setFormData] = useState({});
  const [updatedFormData, setUpdatedFormData] = useState(undefined);
  const [newData, setNewData] = useState(false);
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [viewType, setViewType] = useState("JSON");
  const [guid, setGuid] = useState("");
  const [errorOpen, setErrorOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const didMount = useRef(false);

  useEffect(() => {
    getForm();
  }, []);

  useEffect(() => {
    if (didMount.current || newData == true) {
      setFormData(form);
      setNewData(false);

      var data = JSON.stringify(form, null, 4);

      if (updatedFormData !== undefined) {
        data = JSON.stringify(updatedFormData, null, 4);
      }

      setCode(data);
    } else {
      didMount.current = true;
    }
  }, [newData]);

  function getForm() {
    setLoading(true);

    if (!isNewForm) {
      dispatch(
        getFormJson(formOutlineId, () => {
          setNewData(true);
          setLoading(false);
        })
      );
    } else {
      dispatch(
        clearForm(() => {
          setLoading(false);
        })
      );
    }
  }

  function rightItem() {
    return (
      <div className="button-group">
        {isNewForm ? (
          <ButtonGroup>
            <Button
              variant="outlined"
              color="secondary"
              onClick={() => handleCreate()}
            >
              {t('common.create')}
            </Button>
          </ButtonGroup>
        ) : (
            <ButtonGroup>
              <Button
                variant="outlined"
                color="primary"
                onClick={() => setAlertShowing(true)}
              >
                {t('common.delete')}
              </Button>
              <Button
                variant="outlined"
                color="secondary"
                onClick={() => handleSave()}
              >
                {t('common.save')}
              </Button>
            </ButtonGroup>
          )}
      </div>
    );
  }

  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  function handleValidation() {
    // Validate the form first...
    var errors = validateForm(code);

    if (errors.length === 0) {
      return true;
    } else {
      setErrorOpen(true);
      setErrorMessage(errors[0])
      return false;
    }
  }

  function handleSave() {
    // Validate the form first...
    var isValid = handleValidation();

    if (isValid) {
      dispatch(updateForm(code, () => { }));
    }
  }

  function handleCreate() {
    var isValid = handleValidation();

    if (isValid) {
      dispatch(createForm(code, () => {
        props.history.push("/forms");
      }));
    }
  }

  function handleDelete() {
    dispatch(
      deleteForms([formOutlineId], () => {
        props.history.push("/forms");
      })
    );
  }

  function alertDialog() {
    return (
      <AlertDialog
        title={t("common.remove-question")}
        description={t("common.remove-description")}
        options={[
          {
            label: t('common.cancel'),
            action: () => setAlertShowing(false)
          },
          { label: t('common.delete'), action: () => handleDelete() }
        ]}
        isOpen={alertShowing}
      />
    );
  }

  function handleSnackbarClose() {
    setErrorOpen(false)
  }

  function handleChange(code) {
    setCode(JSON.stringify(code, null, 2));
  }

  var json = "";

  if (code != "") {
    try {
      json = JSON.parse(code);
    } catch (e) {
      // If JSON fails to parse this is fine, we just need to treat it as a String.
      console.log("Failed to parse JSON");
    }
  }

  return (
    <Fragment>
      <CustomizedSnackbars handleClose={() => { setErrorOpen(false) }} open={errorOpen} variant="error" message={errorMessage} />
      {alertDialog()}
      {loading ? (
        <Loading />
      ) : (
          <Fragment>
            <HeaderBlock
              title={
                form.Name === "" || form.Name === undefined
                  ? t('form.untitled')
                  : form.Name
              }
              right={rightItem()}
            />
            <PageContainer className={styles.page}>
              <ScrollableTabs
                tabs={[
                  {
                    name: t('form.editor'),
                    content: <JsonEditor value={json} onChange={handleChange} />
                  },
                  {
                    name: t('form.raw'),
                    content: (
                      <Editor
                        value={code}
                        onValueChange={code => {
                          setCode(code);
                        }}
                        highlight={code => highlight(code, languages.json)}
                        padding={10}
                        className="container__editor"
                      />
                    )
                  }
                ]}
              />
            </PageContainer>
          </Fragment>
        )}
    </Fragment>
  );
}
